// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2Uovg","content":"ManualTimeModal_content__3uJX9"};